module.exports = __webpack_public_path__ + "img/pg.75d5526a.png";